import { useSelector } from 'react-redux';
import { get } from 'global/lib/lodash';

export const useUser = (props) => {
  const me = useSelector((state) => get(state, 'auth.user'));
  const realm = useSelector((state) => get(state, 'auth.realm'));

  return {
    me,
    realm: realm,
    userRealm: get(me, 'realm', {}),
  };
};
